export default "__VITE_ASSET__BvO5hZZN__"